<template>
    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
	 viewBox="0 0 53 53" style="enable-background:new 0 0 53 53;" xml:space="preserve" :width="size" :height="size" class="TQ_Animation_glowing TQ_bg_circle">

        <path style="fill:#EFCE4A;" d="M26.5,9c-8.837,0-16,7.164-16,16c0,7.089,4.615,13.091,11,15.192V50h2v3h6v-3h2v-9.808
            c6.385-2.101,11-8.103,11-15.192C42.5,16.164,35.337,9,26.5,9z"/>

        <g>
            <path style="fill:#EFCE4A;" d="M26.5,0c-0.553,0-1,0.447-1,1v4c0,0.553,0.447,1,1,1s1-0.447,1-1V1C27.5,0.447,27.053,0,26.5,0z"/>
            <path style="fill:#EFCE4A;" d="M50.5,24h-4c-0.553,0-1,0.447-1,1s0.447,1,1,1h4c0.553,0,1-0.447,1-1S51.053,24,50.5,24z"/>
            <path style="fill:#EFCE4A;" d="M6.5,24h-4c-0.553,0-1,0.447-1,1s0.447,1,1,1h4c0.553,0,1-0.447,1-1S7.053,24,6.5,24z"/>
            <path style="fill:#EFCE4A;" d="M42.764,7.322l-2.828,2.828c-0.391,0.391-0.391,1.023,0,1.414c0.195,0.195,0.451,0.293,0.707,0.293
                s0.512-0.098,0.707-0.293l2.828-2.828c0.391-0.391,0.391-1.023,0-1.414S43.154,6.932,42.764,7.322z"/>
            <path style="fill:#EFCE4A;" d="M11.65,38.436l-2.828,2.828c-0.391,0.391-0.391,1.023,0,1.414c0.195,0.195,0.451,0.293,0.707,0.293
                s0.512-0.098,0.707-0.293l2.828-2.828c0.391-0.391,0.391-1.023,0-1.414S12.041,38.045,11.65,38.436z"/>
            <path style="fill:#EFCE4A;" d="M41.35,38.436c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414l2.828,2.828
                c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414L41.35,38.436z"/>
            <path style="fill:#EFCE4A;" d="M10.236,7.322c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414l2.828,2.828
                c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414L10.236,7.322z"/>
        </g>

        <path style="fill:#F7E6A1;" d="M15.5,26c-0.553,0-1-0.447-1-1c0-6.617,5.383-12,12-12c0.553,0,1,0.447,1,1s-0.447,1-1,1
            c-5.514,0-10,4.486-10,10C16.5,25.553,16.053,26,15.5,26z"/>
        <polygon style="fill:#556080;" points="21.5,43 21.5,50 23.5,50 23.5,53 29.5,53 29.5,50 31.5,50 31.5,43 "/>

    </svg>
</template>

<script>
    export default {
        name: "si_clue",
        props:{
            size:{
                type: String,
                default: '48px'
            }
        }
    }
</script>

<style scoped>


</style>